/**
 * Secondary 2 Math tuition hub page with stream selection.
 *
 * What: Hub page for Sec 2 Mathematics across all streams (G1/G2/G3/IP).
 * Why: Provides stream selection and targeted information for Sec 2 students and parents.
 * When: Update when Sec 2 curriculum changes or new streams are added.
 */
import React, { useMemo } from 'react';

import LevelPageLayout from '@/components/levels/LevelPageLayout.js';
import SchoolDirectory from '@/components/schools/SchoolDirectory.js';
import { toLevelPageLayoutContent } from '@/content/levelPageLayoutAdapter';
import { buildSecondaryHubContent } from '@/content/levels/secondaryHubContent';
import { useSchoolDirectory } from '@/hooks/useSchoolDirectory.js';

function Sec2Page() {
  const layoutContent = useMemo(
    () =>
      toLevelPageLayoutContent(buildSecondaryHubContent(2), {
        levelLabel: 'Secondary 2',
      }),
    []
  );
  const { schools, isLoading, hasLoadError } = useSchoolDirectory({
    schoolType: 'secondary',
  });

  return (
    <LevelPageLayout content={layoutContent}>
      <SchoolDirectory
        schools={schools}
        heading="Secondary Schools in Singapore"
        isLoading={isLoading}
        emptyStateMessage={
          hasLoadError
            ? 'Unable to load schools right now.'
            : 'No schools found for this zone.'
        }
      />
    </LevelPageLayout>
  );
}

export default Sec2Page;
